import React from 'react'
import ListOderTime from '../../../components/organisms/admin/oder-time/ListOderTime'

type Props = {}

const ListOderTimePage = (props: Props) => {
  return (
    <ListOderTime />
  )
}

export default ListOderTimePage